module.exports = __webpack_public_path__ + "img/粘贴.e08c5894.svg";